import { render, staticRenderFns } from "./aside-navigation.vue?vue&type=template&id=405842b8&scoped=true&"
import script from "./aside-navigation.vue?vue&type=script&lang=js&"
export * from "./aside-navigation.vue?vue&type=script&lang=js&"
import style0 from "./aside-navigation.vue?vue&type=style&index=0&id=405842b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405842b8",
  null
  
)

export default component.exports